function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewLogoSimple = function SvgNewLogoSimple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 825 417",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,379.432,214.919)"
  }, React.createElement("path", {
    d: "M0,37.606C-3.408,34.747 -8.296,34.587 -11.938,37.142C-14.37,38.848 -17.316,39.794 -20.799,39.794C-32.377,39.794 -37.457,29.933 -37.457,18.728C-37.457,7.449 -32.228,-2.188 -21.098,-2.188C-18.258,-2.188 -15.784,-1.545 -13.649,-0.344C-9.661,1.899 -4.719,1.516 -1.213,-1.425C-5.86,-7.323 -12.713,-10.704 -21.396,-10.704C-38.577,-10.704 -48.288,2.07 -48.288,18.877C-48.288,35.76 -38.502,48.31 -21.247,48.31C-11.651,48.31 -4.61,44.288 0,37.606",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,736.38,278.788)"
  }, React.createElement("path", {
    d: "M0,6.95L-13.447,6.95L-13.447,-16.62L0,-16.62C5.676,-16.62 11.616,-11.277 11.616,-4.181C11.616,2.841 5.676,6.95 0,6.95M0.373,-25.21L-24.054,-25.21L-24.054,6.95L-39.217,6.95L-51.319,-25.21L-64.092,-25.21L-85.681,32.16L-74.849,32.16L-69.844,18.116L-66.782,9.6L-57.967,-15.051L-57.818,-15.051L-49.89,6.954C-55.265,6.992 -60.118,10.364 -61.827,15.467L-46.997,15.467L-40.935,32.16L-29.73,32.16L-35.984,15.541L-24.054,15.541L-24.054,32.16L-13.854,32.16C-13.629,32.16 -13.447,31.977 -13.447,31.752L-13.447,15.541L0.149,15.541C12.026,15.541 21.214,7.622 21.214,-4.405C21.214,-16.432 11.803,-25.21 0.373,-25.21",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,153.235,416.023)"
  }, React.createElement("path", {
    d: "M0,-58.119C-5.627,-58.119 -10.188,-53.558 -10.188,-47.931L-10.188,-22.18C-10.188,-21.586 -10.203,-21.017 -10.227,-20.464L-10.227,-18.556C-10.227,-10.395 -14.995,-3.347 -21.896,-0.043C-21.424,-0.017 -20.946,0 -20.455,0C-13.297,0 -8.098,-1.842 -4.859,-5.526C-1.62,-9.209 0,-14.864 0,-22.493L0,-58.119Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,87.6583,381.802)"
  }, React.createElement("path", {
    d: "M0,2.122C1.44,0.372 2.547,-1.617 3.313,-3.801C1.918,-1.828 -0.372,-0.839 -3.562,-0.839C-8.29,-0.839 -11.085,-2.511 -11.947,-5.855L-21.038,-5.855C-20.751,-1.44 -19.145,2.008 -16.218,4.49C-14.02,6.355 -11.3,7.515 -8.067,7.977C-4.848,6.66 -2.109,4.685 0,2.122",
    style: {
      fill: "white",
      fillOpacity: 0.75,
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,379.053,214.597)"
  }, React.createElement("path", {
    d: "M0,37.568C-3.405,34.712 -8.288,34.552 -11.926,37.104C-14.356,38.809 -17.298,39.754 -20.778,39.754C-32.344,39.754 -37.419,29.903 -37.419,18.709C-37.419,7.442 -32.195,-2.185 -21.076,-2.185C-18.24,-2.185 -15.769,-1.543 -13.636,-0.343C-9.652,1.898 -4.714,1.515 -1.212,-1.423C-5.854,-7.315 -12.7,-10.693 -21.374,-10.693C-38.538,-10.693 -48.239,2.068 -48.239,18.859C-48.239,35.724 -38.464,48.261 -21.225,48.261C-11.64,48.261 -4.605,44.244 0,37.568",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,682.21,50.1391)"
  }, React.createElement("path", {
    d: "M0,9.229C-3.711,12.94 -9.009,14.389 -13.944,13.373L-9.923,17.394C-4.928,22.389 3.171,22.389 8.166,17.394L34.215,-8.655C29.712,-13.158 22.411,-13.16 17.905,-8.658L0,9.229Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), React.createElement("g", {
    transform: "matrix(3.60292,2.09287,2.09287,-3.60292,602.984,90.514)"
  }, React.createElement("path", {
    d: "M3.698,0.035C8.771,0.875 13.16,4.468 14.793,9.639L3.698,12.581C-2.777,14.297 -9.416,10.441 -11.133,3.967L3.698,0.035Z",
    style: {
      fill: "white",
      fillOpacity: 0.75,
      fillRule: "nonzero"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNewLogoSimple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new-logo-simple.65e83a97.svg";
export { ForwardRef as ReactComponent };